<div class="row align-items-center search-generic-container">
  <!-- Left side: image -->
  <div class="search-generic-image col-2 d-none d-md-block">
    <img src="{{searchResultEntry.image}}" class="img-fluid" alt=""/>
  </div>

  <!-- Right side: Text content-->
  <div class="col col-md-10 search-generic-col-right">
    <!-- Title -->
    <div class="search-generic-title">
      <a href="{{searchResultEntry.uri}}" class="search-generic-title-url" [appResultClickTracking]="searchResultEntry">
        <em *ngIf="searchResultEntry.solved" class="fas fa-check search-generic-community-solved"></em>
        <span *ngIf="searchResultEntry.titlePrefix" class="search-generic-title-prefix">{{searchResultEntry.titlePrefix}}: </span>
        <span [innerHTML]="searchResultEntry.title"></span>
      </a>
    </div>

    <!-- Teaser -->
    <p class="search-generic-teaser" [innerHTML]="searchResultEntry.teaser"></p>

    <!-- Dispaly URL -->
    <div class="search-generic-display-url-div">
      <a href="{{searchResultEntry.uri}}" class="search-generic-display-url" [appResultClickTracking]="searchResultEntry">{{searchResultEntry.uri}}</a>
    </div>

    <!-- Extra Fields-->
    <div class="search-generic-extra-fields" *ngIf="searchResultEntry.extraFields">
      <div *ngFor="let item of searchResultEntry.extraFields | keyvalue">
        <span class="search-generic-extra-field">
          <span class="search-generic-extra-field-key">{{item.key}}:</span>
          {{item.value}}</span>
      </div>
    </div>
  </div>
</div>
